import { render, staticRenderFns } from "./FormPain.vue?vue&type=template&id=42319f75&"
import script from "./FormPain.vue?vue&type=script&lang=js&"
export * from "./FormPain.vue?vue&type=script&lang=js&"
import style0 from "./FormPain.vue?vue&type=style&index=0&id=42319f75&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports